import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService{

  _baseUrl: string;

  constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._baseUrl = baseUrl;
  }

  getCurrentUser(): Observable<any> {
    const requestUrl = this._baseUrl + 'api/user/CurrentUser';
    return this._httpClient.get(requestUrl);
  }
}


export interface ApplicationUser extends IdentityUser {
  isActive: boolean;
  tPID: string;
  mailbox: number | null;
  fullName: string;
  createdDate: string;
  modifiedDate: string | null;
}

export interface IdentityUser {
  id: string;
  userName: string;
  normalizedUserName: string;
  email: string;
  normalizedEmail: string;
  emailConfirmed: boolean;
  passwordHash: string;
  securityStamp: string;
  concurrencyStamp: string;
  phoneNumber: string;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  lockoutEnd: string | null;
  lockoutEnabled: boolean;
  accessFailedCount: number;
}
